import { createApp, nextTick } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import './assets/font/iconfont.css'
import ElementPlus from 'element-plus'
import 'element-plus/dist/index.css'
import { zhCn } from 'element-plus/es/locale'
import { Popup } from 'vant';
import 'vant/lib/index.css';
// import awsui from "../lib/awsui.umd.min"; //注意awsui组件库根据情况指定路径1
// import "../lib/awsui.css";
import './assets/css/code-mirror-theme.css'
import axios from './utils/http/index'
import Cookies from 'js-cookie';
import FingerprintJS from '@fingerprintjs/fingerprintjs';
// import * as ElementPlusIconsVue from '@element-plus/icons-vue'
const app=createApp(App)
app.config.globalProperties.axios=axios
app.config.globalProperties.Cookies=Cookies
// for ([name, comp] of Object.entries(ElementPlusIconsVue)) {
//     app.component(name, comp);
//   }
import dataJson from '@/assets/json/data.json'
if(window.location.origin.includes('yijingcloud')){
    app.config.globalProperties.platformJson=dataJson.yj
}else if(window.location.origin.includes('awspaas')){
    app.config.globalProperties.platformJson=dataJson.paas
}else{
    app.config.globalProperties.platformJson=dataJson.paas
}
router.beforeEach((to,from,next)=>{
    // to.meta.title='易鲸云 - 帮助中心'
    if(to.query&&to.query.sid){
        document.cookie=`awssid=${to.query.sid}`;
    }
    let pcList=['/index','/search','/updateArticle','/isArticle']//'/article',
    let mList=['/mhome','/mNav',]//'/marticle'
    var sUserAgent:any = navigator.userAgent.toLowerCase();
    var bIsIpad = sUserAgent.match(/ipad/i) == "ipad";
    var bIsIphoneOs = sUserAgent.match(/iphone os/i) == "iphone os";
    var bIsMidp = sUserAgent.match(/midp/i) == "midp";
    var bIsUc7 = sUserAgent.match(/rv:1.2.3.4/i) == "rv:1.2.3.4";
    var bIsUc = sUserAgent.match(/ucweb/i) == "ucweb";
    var bIsAndroid = sUserAgent.match(/android/i) == "android";
    var bIsCE = sUserAgent.match(/windows ce/i) == "windows ce";
    var bIsWM = sUserAgent.match(/windows mobile/i) == "windows mobile";
    var equipmentType=''
    if (bIsIpad || bIsIphoneOs || bIsMidp || bIsUc7 || bIsUc || bIsAndroid || bIsCE || bIsWM) {
        store.commit('SET_EQUIPMENT_TYPE','phone')
        equipmentType='phone'
        let ua:any=navigator.userAgent.toLowerCase();
        // 由于微信和钉钉的浏览器内核不支持md文档编辑器，需要在手机浏览器去打开
        // if(ua.match(/MicroMessenger/i) == "micromessenger"||ua.indexOf('dingtalk') !== -1){
        if(ua.indexOf('dingtalk') !== -1){
            // 这两个应用打开跳转提示页面
            if(to.path=='/openAdvicse'){
                next()
            }
            next('/openAdvicse')
        }else{
            // 正常的移动浏览器打开
            if(to.path.indexOf('/marticle')>=0){
                next()
            }
            if(mList.indexOf(to.path)>=0){
                next()
            }else{
                // if(to.path=='/marticle'||to.path=='/article'){
                if(to.path.indexOf('article')>=0){
                    let pathL=to.path.split('article/')
                    let id=pathL[pathL.length-1]
                    next(`/marticle/${id}?bookId=${to.query.bookId}`)
                }else{
                    next('/mhome')
                }
            }
        }
    } else {
        store.commit('SET_EQUIPMENT_TYPE','pc')
        equipmentType='pc'
        if(to.path.indexOf('/article')>=0){
            next()
        }
        if(pcList.indexOf(to.path)>=0){
            next()
        }else{
            // if(to.path=='/marticle'||to.path=='/article'){
            if(to.path.indexOf('article')>=0){
                let pathL=to.path.split('article/')
                let id=pathL[pathL.length-1]
                next(`/article/${id}?bookId=${to.query.bookId}`)
            }else{
               next('/index') 
            }
        }
    }
})

//获取浏览器指纹ID 并全局共享

FingerprintJS.load().then(fp => {
    fp.get().then(result => {
      // 获取设备指纹
      const fingerprint = result.visitorId;
      console.log('Visitor Fingerprint:', fingerprint);
  
      // 将指纹信息挂载到全局属性中，方便在组件中使用
      app.config.globalProperties.$fingerprint = fingerprint;
      Cookies.set('BROWSER_ID', fingerprint, { expires: 7 });
    });
});

app.use(store).use(Popup).use(router).use(ElementPlus,{locale:zhCn}).mount('#app')
// .use(awsui)

